import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useNavigate } from "react-router-dom";

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const poll = async () => {
    try {
      const [c, l] = await Promise.all([
        api.get("/notifications/unread-count"),
        api.get("/notifications"),
      ]);
      setCount(c.data.count || 0);
      setItems(l.data || []);
    } catch {}
  };

  useEffect(() => {
    poll();
    const id = setInterval(poll, 20000);
    return () => clearInterval(id);
  }, []);

  const openNotif = async (n) => {
    if (!n.is_read) {
      await api.post(`/notifications/${n.id}/read`).catch(() => {});
    }
    setOpen(false);
    if (n.link) nav(n.link);
    poll();
  };

  const markAll = async () => {
    await api.post("/notifications/read-all").catch(() => {});
    poll();
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid="notification-bell"
          className="relative w-10 h-10 border border-neutral-800 hover:border-[#FF6600] hover:text-[#FF6600] flex items-center justify-center no-transition-all text-neutral-400"
          style={{ transition: "border-color 0.15s ease, color 0.15s ease" }}
        >
          <Bell size={16} />
          {count > 0 && (
            <span
              data-testid="notification-count"
              className="absolute -top-1 -right-1 w-5 h-5 bg-[#FF6600] text-black text-[10px] font-bold font-mono flex items-center justify-center"
            >
              {count > 9 ? "9+" : count}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-96 p-0 rounded-none bg-[#0A0A0A] border-neutral-800"
      >
        <div className="flex items-center justify-between border-b border-neutral-800 px-4 py-3">
          <div className="font-display font-black">Notifikasi</div>
          {count > 0 && (
            <button onClick={markAll} className="text-xs font-mono uppercase text-neutral-500 hover:text-[#FF6600]">
              Tandai semua
            </button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-6 text-center text-xs font-mono text-neutral-500">Tidak ada notifikasi</div>
          ) : (
            items.map((n) => (
              <button
                key={n.id}
                data-testid={`notification-${n.id}`}
                onClick={() => openNotif(n)}
                className={`w-full text-left px-4 py-3 border-b border-neutral-800 hover:bg-neutral-900 no-transition-all ${
                  !n.is_read ? "bg-neutral-900/50" : ""
                }`}
              >
                <div className="flex items-start gap-2">
                  {!n.is_read && <span className="mt-1.5 w-2 h-2 bg-[#FF6600] shrink-0"></span>}
                  <div className="flex-1 min-w-0">
                    <div className="font-mono text-sm font-bold truncate">{n.title}</div>
                    <div className="text-xs text-neutral-400 mt-0.5 line-clamp-2">{n.message}</div>
                    <div className="text-[10px] font-mono text-neutral-600 mt-1">
                      {new Date(n.created_at).toLocaleString("id-ID")}
                    </div>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
